import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))
function B_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <B_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <B_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function B_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  return (
    <>
      <div className={classes.root}>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              Why is Bioinformatics important today?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              It is crucial for genomics, personalized medicine, drug discovery, and understanding complex diseases through large-scale biological data analysis.
              discipline.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What is the future of Bioinformatics?
              
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
             With the rise of AI and big data, bioinformatics is rapidly expanding in genomics, proteomics, and precision healthcare, offering vast career opportunities.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What are the potential career paths and growth opportunities in Bioinformatics?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
               Bioinformatics professionals can work in healthcare, biotechnology, pharmaceuticals, research institutes, and academia, with opportunities to grow into leadership, research, or AI-driven genomic data roles
            
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What job roles are available in Bioinformatics?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              There are various roles in Bioinformatics, including:
              <ul>
                <li>Bioinformatics Analyst</li>
                <li>Genomics Data Scientist</li>
               <li>Computational Biologist</li>
               <li>Clinical Bioinformatician</li>
               <li>Research Scientist</li>
             </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        {/* <Accordion
          className="py-2"
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5bh-content"
            id="panel5bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What are the potential career paths and growth opportunities in
              AI?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              AI offers numerous career growth opportunities, including moving
              into leadership roles such as AI team lead or chief data officer.
              Professionals can also specialize further in specific areas of AI,
              like deep learning or robotics, or transition into related fields
              such as data analytics, business intelligence, or software
              engineering.
            </Typography>
          </AccordionDetails>
        </Accordion> */}
      </div>
    </>
  )
}
export default B_FAQ_page
